import {
    ExpandLess,
    ExpandMore,
    Home,
    ManageAccounts,
    Settings,
} from "@mui/icons-material";
import AutoAwesomeMosaicOutlinedIcon from "@mui/icons-material/AutoAwesomeMosaicOutlined";
import {
    Box,
    CssBaseline,
    Divider,
    IconButton,
    List,
    ListItem,
    ListItemText,
    Toolbar,
    Typography,
    Collapse,
} from "@mui/material";
import * as React from "react";
import { useNavigate, Outlet } from "react-router-dom";

import logoImage from "../../assets/images/logoTopTecnologiaLoginPage.png";
import { useAuth } from "../../contexts/contexts";
import { If } from "../If";
import { UserMenu } from "../UserMenu";
import { navigationItems } from "./navigationItems";
import {
    AppBar,
    Drawer,
    DrawerHeader,
    ListItemButton,
    ListItemIcon,
    Logo,
} from "./styles";

export default function Sidebar() {
    const navigate = useNavigate();
    const { hasPermissions, signOut, user } = useAuth();

    const [open, setOpen] = React.useState(true);
    const [openCollapse, setOpenCollapse] = React.useState<string>("");

    return (
        <Box sx={{ display: "flex" }}>
            <CssBaseline />
            <AppBar position="fixed" open={open}>
                <Toolbar>
                    <IconButton onClick={() => setOpen(!open)}>
                        <AutoAwesomeMosaicOutlinedIcon />
                    </IconButton>
                    <Box display="flex" flex={1} justifyContent="flex-end">
                        <UserMenu
                            name={user?.name ?? "User"}
                            onSignOut={signOut}
                        />
                    </Box>
                </Toolbar>
            </AppBar>

            <Drawer variant="permanent" open={open}>
                <DrawerHeader>
                    <Box display="flex" alignItems="center" gap={2}>
                        <Logo src={logoImage} alt="704 Apps Logo" />
                        <Typography variant="h6">
                            <strong>Admin</strong>
                        </Typography>
                    </Box>
                </DrawerHeader>

                <Divider />

                <List>
                    <If condition={hasPermissions("ana.home")}>
                        <ListItem disablePadding>
                            <ListItemButton onClick={() => navigate("/home")}>
                                <ListItemIcon>
                                    <Home />
                                </ListItemIcon>
                                <ListItemText primary="Início" />
                            </ListItemButton>
                        </ListItem>
                    </If>

                    {navigationItems.map(
                        (menu) =>
                            hasPermissions(menu.permission) && (
                                <React.Fragment key={menu.id}>
                                    <ListItemButton
                                        onClick={() => {
                                            if (!open) return;

                                            setOpenCollapse(
                                                openCollapse === menu.id
                                                    ? ""
                                                    : menu.id
                                            );
                                        }}
                                    >
                                        <ListItemIcon>{menu.icon}</ListItemIcon>
                                        <ListItemText primary={menu.text} />
                                        {openCollapse === menu.id ? (
                                            <ExpandLess />
                                        ) : (
                                            <ExpandMore />
                                        )}
                                    </ListItemButton>

                                    <Collapse
                                        in={openCollapse === menu.id}
                                        unmountOnExit
                                    >
                                        <List component="div" disablePadding>
                                            {menu.subItems.map(
                                                (sub) =>
                                                    hasPermissions(
                                                        sub.permission
                                                    ) && (
                                                        <ListItemButton
                                                            key={sub.url}
                                                            sx={{ pl: 5 }}
                                                            onClick={() =>
                                                                navigate(
                                                                    sub.url
                                                                )
                                                            }
                                                        >
                                                            <ListItemIcon>
                                                                {sub.icon}
                                                            </ListItemIcon>
                                                            <ListItemText
                                                                primary={
                                                                    sub.text
                                                                }
                                                            />
                                                        </ListItemButton>
                                                    )
                                            )}
                                        </List>
                                    </Collapse>
                                </React.Fragment>
                            )
                    )}

                    <Divider />

                    <If condition={hasPermissions("configuracoes.visualizar")}>
                        <ListItemButton onClick={() => navigate("/settings")}>
                            <ListItemIcon>
                                <ManageAccounts />
                            </ListItemIcon>
                            <ListItemText primary="Configurações" />
                        </ListItemButton>
                    </If>

                    <If condition={hasPermissions("configuracoes.visualizar")}>
                        <ListItemButton
                            onClick={() => navigate("/ana/listagem-clientes")}
                        >
                            <ListItemIcon>
                                <Settings />
                            </ListItemIcon>
                            <ListItemText primary="Ana" />
                        </ListItemButton>
                    </If>
                </List>
            </Drawer>

            <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
                <DrawerHeader />
                <Outlet />
            </Box>
        </Box>
    );
}
